export const LOCAL_STORAGE_KEYS = {
  SELECTED_PRIMARY_ORG: 'selectedPrimaryOrg',
  TRANSLOCO_LANG: 'translocoLang'
} as const;

export const SESSION_STORAGE_KEYS = {
  LOGIN_REDIRECTED_AT: 'loginRedirectedAt'
} as const;
